import { switchClasses } from "@mui/material";
import { green, grey } from "../../theme/palette/colors/index.js";
const MuiSwitch = {
    defaultProps: {
        color: 'primary'
    },
    styleOverrides: {
        root: {
            padding: 9
        },
        switchBase: ({ theme })=>({
                margin: 1,
                [`&.${switchClasses.checked}`]: {
                    [`& + .${switchClasses.track}`]: {
                        backgroundColor: green["600"],
                        opacity: 1
                    }
                },
                [`&.${switchClasses.disabled}`]: {
                    [`& > .${switchClasses.thumb}`]: {
                        backgroundColor: 'light' === theme.palette.mode ? grey["100"] : grey["700"]
                    },
                    [`& + .${switchClasses.track}`]: {
                        opacity: 0.3
                    }
                }
            }),
        thumb: ({ theme })=>({
                backgroundColor: theme.palette.common.white,
                height: 18,
                width: 18
            }),
        track: ({ theme })=>({
                backgroundColor: 'light' === theme.palette.mode ? grey["400"] : grey["600"],
                borderRadius: 12,
                opacity: 1
            })
    }
};
export { MuiSwitch };

//# sourceMappingURL=switch-overrides.js.map